export default "__VITE_ASSET__DBsCESx9__"